import classNames from 'classnames'
import { memo } from 'react'

import styles from './Sidebar.module.scss'

type Props = {
  country?: string
  isGuide?: boolean
}

const Sidebar = ({ country: _, isGuide }: Props) => {
  // if (country === 'MX') {
  //   const randomAd = getRandomAd('tcg.land/sidebar')
  //   return (
  //     <div className={styles.sidebar}>
  //       <OutboundLink url={tcgLandUrl} utm_medium='sidebar'>
  //         <img alt='TCG.Land' className={styles.tcgland} src={randomAd.src} />
  //       </OutboundLink>
  //     </div>
  //   )
  // }

  return (
    <div
      className={classNames(styles.sidebar, process.env.NODE_ENV === 'production' ? 'mvSidebar1' : 'dev-ad', {
        [styles.guide]: isGuide,
      })}
    />
  )
}

export default memo(Sidebar)
